export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-input/index.js